/* Scan the document for clicks that might hit a yet to exist filter button */
document.addEventListener("click", (event) => {
  const element = event.target;

  if (element.getAttribute("data-searchfilter")) {
    const filter = element.getAttribute("data-searchfilter");
    searchdrawer_setFilterClasses(filter);

    event.preventDefault();
  }
});

function searchdrawer_setFilterClasses(filter) {
  const resultsEl = document.getElementById("fostr-contentdrawer-search");
  resultsEl.classList.remove("filter-by-product");
  resultsEl.classList.remove("filter-by-page");
  resultsEl.classList.remove("filter-by-article");

  resultsEl.classList.add("filter-by-" + filter);
}
